/*=========================================================================================
  File Name: moduleCompanyGetters.js
  Description: Company Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	getLastCheckedResource: (state) => () => state.resourcesActivity.slice(-1),
	getSelectedResource: (state) => (param) => state.resources.find((resource) => resource.selected),
};
